import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {    
	'es': {
		superadaAntelacionMaxima: 'No es posible reservar con una antelación mayor de 183 días (6 meses aprox.)',
		horaInicialErronea: 'Hora de entrada errónea',
		tiempoRestanteParaFinalizarReserva: 'Tiempo para finalizar la reserva: ',
		errorCaracteresMatricula: 'Solo letras y números',
		errorObteniendoDisponibilidad: 'Error obteniendo la disponibilidad de plazas.',
		plazasNoDiponibles: 'No hay plazas disponibles para las fechas marcadas.',
		obtenerFactura: 'Obtener factura',
		cancelarReserva: 'Cancelar reserva',
		avisolegal: 'Términos del servicio',
		politicaprivacidad:'Política de Privacidad',	
		pagoseguro:	'Pago seguro con',
		copyright:'Creado por',
		horario:'Lunes a domingo 24 horas',
		comollegar: 'CÓMO LLEGAR',
		minutos: 'minutos',
		puertobarcelona: 'Puerto de Barcelona',
		palaciovirreina: 'Palacio de la Virreina',
		teatroliceo: 'Gran teatro del Líceo',
		larambla: 'La Rambla',
		boqueria: 'Mercado de la Boquería',
		plazareal: 'Plaza Real',
		direccionpuerto: 'Puerto de Barcelona',
		direccionpalacio: 'La Rambla, 99, 08001 Barcelona',
		direccionteatro: 'La Rambla, 51-59, 08002 Barcelona',
		direccionrambla: 'La Rambla, 08002 Barcelona',
		direccionboqueria: 'La Rambla, 91, 08001 Barcelona',
		direccionplazareal: 'Plaza Real, 9, 08002 Barcelona',
		dia: 'día',
		dias: 'días',
		duracion: 'Duración',
		importe: 'Importe',
		tablaTarifaDias: 'Días',
		tablaTarifaPrecio1: 'Precio exclusivo online',
		tablaTarifaPrecio2: '',
		tablaTarifaTitulo: 'NUESTRA TARIFA',
		errorObteniendoTarifa: 'Tarifa no descargada',
		datosReservaTitulo: 'COMPLETA TU RESERVA',
		datosReservaFechaEntrada: 'Fecha de entrada',
		datosReservaFechaSalida: 'Fecha de Salida',
		datosReservaMatricula: 'Matrícula',
		datosReservaModelo: 'Modelo del vehículo',
		datosReservaColor: 'Color del vehículo',
		datosReservaCrucero: 'Crucero',
		datosReservaPrecioTotal: 'Reserva de parking:',
		datosReservaTotal: 'Total',
		datosReservaNombre:'Nombre completo',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Teléfono',
		datosReservaAceptoCondiciones: 'Acepto los términos y condiciones del servicio',
		datosReservaInformacionFacturacion: 'Datos de facturación',
		datosReservaNombreFac: 'Nombre',
		datosReservaCif: 'CIF',
		datosReservaDireccion: 'Dirección',
		datosReservaLocalidad: 'Localidad',
		datosReservaCp: 'Código postal',
		datosReservaLocalizador: 'Localizador',
		datosReservaQR: 'Código QR',
		miReservaTitulo: 'Datos de la reserva',
		errorNoNombre: 'Campo obligatorio',
		errorNoEmail: 'Campo obligatorio',
		errorEmailErroneo: 'Introduzca un email válido',
		errorNoAceptaTerminos: 'Campo obligatorio',
		errorNoTelefono: 'Campo obligatorio',
		errorNoFechaEntrada: 'Campo obligatorio',
		errorNoFechaSalida: 'Campo obligatorio',
		errorNoMatricula: 'Campo obligatorio',
		errorNoModelo: 'Campo obligatorio',
		errorNoColor: 'Campo obligatorio',
		errorNoCrucero: 'Campo obligatorio',
		errorNoLocalizador: 'Campo Obligatorio',
		errorReservaNoEncontrada: 'Reserva no encontrada',
		btnBuscarReserva: 'Buscar reserva',
		btnReservar: 'Reservar',
		btnTerminar: 'Terminar',
		btnImprimir: 'Imprimir',
		btnContinuar: 'Continuar',
		btnCancelar: 'Cancelar',
		btnSolicitarFactura: 'Solicitar factura',
		fechaFinalErronea: 'Fecha final errónea',
		reservaMayorPermitido: 'La reserva supera la duración máxima permitida (14 días)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Puntos cercanos',
		descripcionParking: 'Descripción',
		descripcionParkingP1: 'Parking Barcelona Port es un aparcamiento público situado dentro del Puerto de Barcelona, al lado de la terminal E, HELIX.',
		descripcionParkingP2: 'Podrás dejar tu coche aparcado de forma segura y disfrutar de tus vacaciones sin preocupaciones y evitando buscar traslados. El aparcamiento ideal si te vas de crucero con Costa Cruceros, Aida cruises, entre muchos otros operadores, ya que el parking está a escasos minutos caminando de las terminales desde donde salen.',
		descripcionParkingP3: 'A través de nuestra web podrás reservar una plaza en nuestro parking para tu coche durante las fechas que selecciones. De esta forma, te aseguras de aparcar.',
		descripcionParkingP4: 'Disponemos en total de 275 plazas de aparcamiento, más 9 plazas habilitadas para discapacitados. Disponibles para aparcar los 365 días del año y abierto las 24 horas. Todas nuestras plazas de parking son descubiertas y están vigiladas en todo momento por cámaras de seguridad.',
		presentacionDireccion: 'Dirección',
		presentacionHorario: 'Horarios',
		presentacionServicios: 'Servicios',
		presentacionPubli: 'Reserva Online tu aparcamiento en el puerto de Barcelona',
		presentacionAccesos: 'Accesos y salidas',
		presentacionDias: 'Lunes a domingo 24 horas',
		presentacionDireccionParking: 'Detrás Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'TUS DATOS',
		steperRealizarPago: 'PAGO',
		stepperResultadoProceso: 'RESULTADO',
		resumenTitulo: 'Resumen de reserva',
		resumenPrecio: 'PRECIO',
		resumenSubTotal: 'Subtotal',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Cancelación gratuita 7 dias antes.',
		resumenPieGarantia:'Plaza de parking garantizada.',
		resumenAvisoDevolucion: 'El importe se abonará en la misma tarjeta utilizada en el pago',
		resumenImporteAbonado: 'Importe abonado',
		condicionesUso: 'Condiciones de Servicios',
		politicaDevolucion: ' Condiciones, Política de Cancelación y Reembolso',
		y:'y',
		resumenAvisoCorreo: 'Recibirás un email con todos los detalles de tu reserva.',
		resumenAvisoCorreoFactura: 'Recibirás un email con tu factura.',
		resumenContacto: 'En caso de que quiera realizar una anulación o un cambio de fecha recuerde que es completamente GRATUITO, envíe un mail a parkingbarcelonaport@es.costa.it',
		stepperContinuarPago: 'Aceptar condicones y continuar con el pago',
		inicioBienvenido: 'BIENVENIDOS',
		inicioNombreParking: 'Parking Barcelona Port',
		inicioReservaConNosotros: 'Si sales en un crucero desde el Moll Adossat del puerto de Barcelona, reserva tu plaza de parking con nosotros. Situado junto a Helix Cruise Center, Terminal E.',
		inicioSomosUnicos: 'SOMOS EL ÚNICO PARKING DE LARGA ESTANCIA EN EL MUELLE DE CRUCEROS DEL PUERTO DE BARCELONA',
		inicioPrecioSemana: '7 días por solo 79€',
		inicioReservarPlaza: 'Reservar una plaza',
		inicioPlazaGarantizada: 'Reservando un plaza con nosotros, tu parking en el puerto de Barcelona está garantizado.',
		inicioCancelacionReembolso: 'Si necesitas cancelar tu reserva, podrás hacerlo con opción a reembolso hasta 7 días antes.',
		inicioAhorra: 'Ahorra con tarifas competitivas para estancia corta y larga.',
		inicioTituloPlazaGarantizada: 'Tu plaza está garantizada',
		inicioTituloCancelacionReembolso: 'Cancelación con reembolso',
		inicioTituloAhorra: 'Ahorra en parking',
		inicioConsulteRestricciones: 'Consulte Restricciones',
		inicioZBE: 'Zona de Bajas Emisiones',
		menuReservar: 'Reservar',
		menuFaq: 'FAQ',
		menuFuncionamiento: '¿Cómo funciona?',
		menuContacto: 'Contacto',
		menuCancelar: 'Cancelar reserva',
		servicioAireLibre: 'Descubierto y abierto 24h',
		servicioCodigoQr: 'Lector de matrículas y código QR',
		servicioVideoVigilancia: 'Videovigilancia',
		servicioAlturaMaxima: 'Altura máxima 2,35m',
		servicioZbe: 'Zona de bajas emisiones',
		servicioPlazasMinusvalidos: 'Plazas para minusválidos',
		servicioCancelacionReserva: 'Cancelación gratuita hasta 7 días antes del inicio de la reserva',
		listadoCruceros: 'Encuentra tu crucero',
		descripcionZBE1: 'Les informamos que desde el 1 de enero el Ayuntamiento de Barcelona ha puesto en funcionamiento la nueva zona de bajas emisiones (ZBE) que restringe la circulación de ciertos vehículos por la ciudad. Es por este motivo que para acceder a nuestro estacionamiento tendrán que comprobar si su vehículo (matrícula nacional o extranjera) está autorizado para poder circular en esta zona.',
		descripcionZBE2: 'Adjuntamos el link de la página oficial del Ayuntamiento de Barcelona, para que puedan acceder a toda la información donde podrán registrarse en caso de ser necesario.',
		preguntasFrecuentes: 'Preguntas frecuentes',
		pregunta1: '¿Cómo se accede al parking? ',
		pregunta1Parrafo1: 'Si ha realizado la reserva a través de nuestra web solamente tiene que acercarse con el coche a la barrera y la barrera se abrirá automáticamente, nuestro sistema leerá su matrícula con una cámara. Es por este motivo que es importante registrar su vehículo correctamente.',
		pregunta1Parrafo2: 'En el caso que el lector no lea correctamente su matrícula puede realizar el acceso mediante el código QR que se le enviará por email cuando realice la reserva. Lo puede llevar impreso o en el móvil.',
		pregunta1Parrafo3: 'Si la barrera no se abre automáticamente por cualquier motivo, podrá contactar directamente con la administración del parking presionando el botón naranja de INFORMACIÓN.',
		pregunta2: '¿Cómo salgo del parking? ',
		pregunta2Parrafo1: 'Si ha realizado la reserva a través de nuestra web solamente tiene que acercarse con el coche a la barrera y la barrera se abrirá automáticamente, nuestro sistema leerá su matrícula con una cámara. Es por este motivo que es importante registrar su vehículo correctamente.',
		pregunta2Parrafo2: 'En el caso que el lector no lea correctamente su matrícula puede realizar el acceso mediante el código QR que se le enviará por email cuando realice la reserva. Lo puede llevar impreso o en el móvil.',
		pregunta2Parrafo3: 'Si la barrera no se abre automáticamente por cualquier motivo, podrá contactar directamente con la administración del parking presionando el botón naranja de INFORMACIÓN.',
		pregunta3: '¿Se puede aparcar en cualquier plaza?',
		pregunta3Parrafo1: 'Sí, la reserva es para cualquier plaza que esté libre en el momento que usted llegue al parking. Hay varias plazas para minusválidos reservadas para personas con movilidad reducida.',
		pregunta3Parrafo2: '',
		pregunta3Parrafo3: '',
		pregunta4: '¿Puedo retirar el coche más tarde de la hora que tenía reservada?',
		pregunta4Parrafo1: 'Le informamos que si no puede llegar a recoger su coche a la hora reservada por la web se tiene que poner en contacto con la administración del parking. Extender la reserva es posible, siempre y cuando haya disponibilidad.',
		pregunta4Parrafo2: '',
		pregunta4Parrafo3: '',
		pregunta5: 'Si llego antes de la hora reservada, ¿voy a poder entrar?',
		pregunta5Parrafo1: ' Aconsejamos a nuestros clientes que lleguen a la hora reservada, pero entendemos que esto no es siempre posible y, por lo tanto, tenemos un tiempo de cortesía razonable (1 hora antes y 1 hora después de su reserva). Si al llegar, la barrera no se abre automáticamente, ni mediante el código QR, tendrá que contactar con la administración del parking, presionando el botón naranja de INFORMACIÓN. Se otorgará el acceso siempre que haya disponibilidad.',
		pregunta5Parrafo2: '',
		pregunta5Parrafo3: '',
		pregunta6: '¿Puedo modificar mi registro una vez realizada la reserva?',
		pregunta6Parrafo1: 'Sí, tiene que enviar una solicitud de cambio vía email a: parkingbarcelonaport@es.costa.it ,  indicando el código de reserva y el registro se modificará para que no tenga ningún problema al acceder al parking.',
		pregunta6Parrafo2: '',
		pregunta6Parrafo3: '',
		pregunta7: '¿Es fácil encontrar el parking?',
		pregunta7Parrafo1: 'En el Muelle Adosado es el único parking de larga estancia. Nuestro parking tiene barreras de entrada y salida y está ubicado justo al lado de la Terminal E (HELIX). Puede consultar el mapa en nuestra web para más información. Asegúrese de no dejar el coche aparcado en una de las explanadas destinadas a uso de día, porque a su vuelta del crucero su coche podría habérselo llevado la grúa o estar bloqueado con un cepo. ',
		pregunta7Parrafo2: '',
		pregunta7Parrafo3: '',
		pregunta8: '¿Con cuánto tiempo de antelación tengo que hacer la reserva online para beneficiarme del mejor precio?',
		pregunta8Parrafo1: 'Si hay plazas, puede reservar hasta dos horas antes de su llegada.',
		pregunta8Parrafo2: '',
		pregunta8Parrafo3: '',
		pregunta9: '¿El parking está cerca de mi crucero?',
		pregunta9Parrafo1: 'El Muelle Adosado es el muelle en el que se ubican las 5 terminales de cruceros del Puerto de Barcelona.',
		pregunta9Parrafo2: ' Si conoce en qué terminal atracará su barco, ',
		pregunta9link: 'clique aquí',
		pregunta9Parrafo3: ' para conocer la distancia caminando entre las terminales y el parking.',
		pregunta10: '¿Cuáles son las dimensiones máximas de vehículo que acepta el parking?',
		pregunta10Parrafo1: 'El acceso está limitado por una anchura máxima de 300 cm y un gálibo de 235 cm. Las medidas de la plaza son 490x240 cm. No están permitidos autobuses, caravanas de gran tamaño, vehículos con remolque.',
		pregunta10Parrafo2: 'Las plazas para minusválidos están adecuadas a la legislación correspondiente.',
		pregunta10Parrafo3: '',
		pregunta11: '¿Hay estación de recarga eléctrica?',
		pregunta11Parrafo1: 'No, por el momento no disponemos de este servicio.',
		pregunta11Parrafo2: '',
		pregunta11Parrafo3: '',
		pregunta12: '¿Hay servicio de limpieza?',
		pregunta12Parrafo1: 'No, por el momento no disponemos de este servicio.',
		pregunta12Parrafo2: '',
		pregunta12Parrafo3: '',
		pregunta13: '¿El parking está vigilado?',
		pregunta13Parrafo1: 'Sí, está vigilado por CCTV. La zona del Muelle Adosado (donde se encuentra el aparcamiento) es de acceso restringido y cuando no hay cruceros en las terminales no se permite el acceso a personal no autorizado. Las patrullas de Policía Portuaria están constantemente dando vueltas por la zona,',
		pregunta13Parrafo2: '',
		pregunta13Parrafo3: '',
		pregunta14: '¿Es el parking cubierto?',
		pregunta14Parrafo1: 'No, está al descubierto.',
		pregunta14Parrafo2: '',
		pregunta14Parrafo3: '',
		pregunta15: '¿Hay servicio de custodia de llaves?',
		pregunta15Parrafo1: 'No, mantenga las llaves con usted ya que no ofrecemos este servicio.',
		pregunta15Parrafo2: '',
		pregunta15Parrafo3: '',
		pregunta16: '¿Qué pasa si pierdo el ticket?',
		pregunta16Parrafo1: 'Encontrará instrucciones en el cajero automático.',
		pregunta16Parrafo2: '',
		pregunta16Parrafo3: '',
		reservaConfirmada: 'RESERVA CONFIRMADA',
		infoTiempoCortesia: 'Dispondrá de un margen de entrada/salida de una hora respecto al tiempo efectivo de reserva.',
		tablaTarifaDiaPorHoras: 'Un día',
		tablaTarifaHoras: 'Una hora',
		tablaTarifaHorasTitulo: 'Tarifa estándar de estacionamiento',
		tablaTarifaHorasPrecio: 'Precio',
		reservaCancelada: 'La reserva ha sido cancelada y su importe abonado en la tarjeta de crédito',
		datosReservaTarjeta: 'Tarjeta de crédito',
		errorPlazoCancelacion: 'Su reserva empieza en menos de 7 días y no puede ser cancelada por este medio.',
		funcionamientoEstancia: 'Define el periodo de reserva',
		funcionamientoDatosPersonales: 'Identifícate',
		funcionamientoDatosFacturacion: '¿Necesitarás una factura?',
		funcionamientoPago: 'Realiza el pago de la reserva',
		funcionamientoReservaRealizada: 'Enhorabuena, has terminado tu reserva.',
		funcionamientoCancelarReserva: '¿Deseas cancelar tu reserva?',
		funcionamientoP1P1: 'Introduce los datos que definen el periodo de la reserva (día/hora de entrada y día/hora de salida), la información del vehículo que vas a utilizar (número de matrícula, modelo y color) y el crucero en el que embarcarás. Parte de estos datos son exigidos por la Autoridad Portuaria por motivos de seguridad.',
		funcionamientoP1P2: 'Nuestra web te informará del importe a pagar para el periodo de tiempo introducido. Quizás te aparezca un aviso en caso de que la fecha de salida no sea posterior a la de entrada.',
		funcionamientoP1P3: 'Ten presente que la tarifa de reserva web es por días completos. Si seleccionas menos de 24 horas se te cobrará un día de estancia; si superas las 24 horas por un minuto, se te cobrarán dos días.',
		funcionamientoP1P4: 'Pulsa el botón "RESERVAR" para continuar con el proceso.',
		funcionamientoP2P1: 'Necesitamos conocer una información mínima sobre ti, de esta manera podremos tener un canal de comunicación contigo e identificarte en caso de que necesites realizarnos alguna consulta.',
		funcionamientoP3P1:	'Si crees que necesitarás una factura nominativa de tu estancia, introduce los datos fiscales de facturación. No es obligatorio.',
		funcionamientoP4P1: 'En pantalla verás un formulario para introducir los datos de la tarjeta con la que vas a realizar el pago.',
		funcionamientoP4P2: 'Este formulario es totalmente seguro y cumple con la normativa vigente para pagos por internet. Parking Barcelona Port no tiene acceso a los datos de tu tarjeta, ya que se trata de una comunicación directa y blindada con la pasarela de pagos.',
		funcionamientoP5P1: 'Si el proceso de pago concluye correctamente verás esta pantalla de confirmación de reserva.',
		funcionamientoP5P2: 'Los datos más relevantes son el código del localizador de la reserva y el código QR que te servirá para acceder al parking en caso de que hubiera algún problema con el sistema automático de lectura de matrícula.',
		funcionamientoP5P3: 'Recibirás un email con los datos de la reserva. Te recomendamos que conserves este mail por si te lo solicitasen los empleados del parking.',
		funcionamientoP6P1: 'Si faltan más de 7 días hasta el momento de inicio de tu reserva, puedes cancelarla de manera automática y gratuita.',
		funcionamientoP6P2: 'Pulsa el botón "CANCELAR RESERVA" que encontrarás en la barra de menú de la página. Cuando lo hagas aparecerá una ventana para que introduzcas tu email y el número de localizador de la reserva. Con estos datos podremos recuperar toda la información necesaria.',
		funcionamientoP6P3: 'Si estás en plazo de cancelación y has introducido correctamente los datos, se te mostrará toda la información asociada a la reserva: Fecha y hora de inicio, fecha y hora de finalización importe pagado, etc. Pulsando el boton "CANCELAR" se anulará la reserva en el parking y se te devolverá el importe pagado en tu tarjeta de crédito.',

		mensajeCookies: 'Utilizamos cookies propias y de terceros para mejorar la experiencia de usuario y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso.',
		enlaceCookies: 'Política de cookies',
		aceptarCookies: 'Acepto',
		accionesReserva: 'Mis reservas',
		reviseSuCorreo: 'Recibirá un email con la factura'

	},	// fin traduccion a español    

	'en': {
		superadaAntelacionMaxima: 'It is not possible to book more than 183 days in advance (6 months approx.)',
		horaInicialErronea: 'Wrong entry time',
		tiempoRestanteParaFinalizarReserva: 'Time to finalize the reservation: ',
		errorCaracteresMatricula: 'Only letters and numbers',
		errorObteniendoDisponibilidad: 'Error obtaining the availability of places.',
		plazasNoDiponibles: 'There are no places available for the dates indicated.',
		obtenerFactura: 'Get the invoice',
		cancelarReserva: 'Cancel booking',
		avisolegal: 'Terms of Service',
		politicaprivacidad:'Privacy Policy',
		pagoseguro:	'Safe payment with',
		copyright:'Powered by',
		horario:'Monday to Sunday 24 hours',
		comollegar: 'HOW TO GET',
		minutos: 'minutes',
		puertobarcelona: 'Barcelona\'s port',
		palaciovirreina: 'Palace of the Virreina',
		teatroliceo: 'Grand Theater of the Lyceum',
		larambla: 'La Rambla',
		boqueria: 'Boquería Market',
		plazareal: 'Royal Square',
		direccionpuerto: 'Barcelona\'s port',
		direccionpalacio: 'La Rambla, 99, 08001 Barcelona',
		direccionteatro: 'La Rambla, 51-59, 08002 Barcelona',
		direccionrambla: 'La Rambla, 08002 Barcelona',
		direccionboqueria: 'La Rambla, 91, 08001 Barcelona',
		direccionplazareal: 'Royal Square, 9, 08002 Barcelona',
		dia: 'day',
		dias: 'days',
		duracion: 'DURATION',
		importe: 'AMOUNT',
		tablaTarifaDias: 'Days',
		tablaTarifaPrecio1: 'Online exclusive price',
		tablaTarifaPrecio2: '',
		tablaTarifaTitulo: 'OUR RATE',
		errorObteniendoTarifa: 'Rate not downloaded',
		datosReservaTitulo: 'COMPLETE YOUR RESERVATION',
		datosReservaFechaEntrada: 'Entry date',
		datosReservaFechaSalida: 'Departure date',
		datosReservaMatricula: 'License plate',
		datosReservaModelo: 'Vehicle model',
		datosReservaColor: 'Vehicle colour',
		datosReservaCrucero: 'Cruise ship',
		datosReservaPrecioTotal: 'Parking booking',
		datosReservaTotal: 'Total',
		datosReservaNombre:'Full name',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Telephon number',
		datosReservaAceptoCondiciones: 'I accept the terms and conditions of the service',
		datosReservaInformacionFacturacion: 'Invoice data',
		datosReservaNombreFac: 'Full name',
		datosReservaCif: 'VAT',
		datosReservaDireccion: 'Address',
		datosReservaLocalidad: 'City',
		datosReservaCp: 'Zip number',
		datosReservaLocalizador: 'Locator',
		datosReservaQR: 'QR code',
		miReservaTitulo: 'Book data',
		errorNoNombre: 'Mandatory data',
		errorNoEmail: 'Mandatory data',
		errorEmailErroneo: 'Enter a valid email address',
		errorNoAceptaTerminos: 'Mandatory data',
		errorNoTelefono: 'Mandatory data',
		errorNoFechaEntrada: 'Mandatory data',
		errorNoFechaSalida: 'Mandatory data',
		errorNoMatricula: 'Mandatory data',
		errorNoModelo: 'Mandatory data',
		errorNoColor: 'Mandatory data',
		errorNoCrucero: 'Mandatory data',
		errorNoLocalizador: 'Mandatory data',
		errorReservaNoEncontrada: 'Reservation not found',
		btnBuscarReserva: 'Find reservation',
		btnReservar: 'Book',
		btnTerminar: 'Finish',
		btnImprimir: 'Print',
		btnContinuar: 'Continue',
		btnCancelar: 'Cancel',
		btnSolicitarFactura: 'Request invoice',
		fechaFinalErronea: 'Wrong end date',
		reservaMayorPermitido: 'The reservation exceeds the maximum duration allowed (14 days)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Near points',
		descripcionParking: 'Description',
		descripcionParkingP1: 'Parking Barcelona Port is a public car park located inside the Port of Barcelona, ​​on the cruise pier, adjacent to Helix Cruise Centre, Terminal E.',
		descripcionParkingP2: 'You can safely park your vehicle and enjoy your vacation without worry and avoid the hassle of arranging a transfer. The ideal parking if you go on a cruise with Costa Cruceros, Aida cruises, among many others since the parking is just a few minutes walk from the cruise terminals A, B, C, D and E.',
		descripcionParkingP3: 'Through our website you can reserve a space in our parking lot for your car for the period you select. Once booked, your space is guaranteed.',
		descripcionParkingP4: 'We have a total of 275 parking spaces, plus 9 disabled spaces. Available to park 365 days a year and open 24/7. All our parking spaces are uncovered and are monitored at all times by security cameras.',
		presentacionDireccion: 'Location',
		presentacionHorario: 'Schedule',
		presentacionServicios: 'Services',
		presentacionPubli: 'Reserve your space online in the Port of Barcelona',
		presentacionAccesos: 'Accesses and exits',
		presentacionDias: 'Monday to Sunday 24 hours',
		presentacionDireccionParking: 'Adjacent to Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'YOUR DATA',
		steperRealizarPago: 'PAYMENT',
		stepperResultadoProceso: 'BOOKED',
		resumenTitulo: 'Booking summary',
		resumenPrecio: 'PRICE',
		resumenSubTotal: 'Subtotal',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Free cancellation 7 hours before.',
		resumenPieGarantia:'Guaranteed parking space.',
		resumenAvisoDevolucion: 'The amount will be paid on the same card used in the payment',
		resumenImporteAbonado: 'Amount paid',
		condicionesUso: 'Terms of Service',
		politicaDevolucion: ' Conditions, Cancellation and Refund Policy',
		y:'and',
		resumenAvisoCorreo: 'You will receive an email with all the details of your reservation.',
		resumenAvisoCorreoFactura: 'You will receive an email with your invoice.',
		resumenContacto: 'In case you want to make a cancellation or a change of date remember that it is completely FREE, sending and email to parkingbarcelonaport@es.costa.it',
		stepperContinuarPago: 'Aceptar condiciones y continuar con el pago',
		inicioBienvenido: 'WELCOME',
		inicioNombreParking: 'Parking Barcelona Port',
		inicioReservaConNosotros: 'If you are departing on a cruise from Barcelona, reserve your parking space with us. Our car park is located adjacent to Helix Cruise Centre, Terminal E – on the cruise pier.',
		inicioSomosUnicos: 'WE ARE THE ONLY LONG STAY CAR PARK ON THE CRUISE PIER IN THE PORT OF BARCELONA',
		inicioPrecioSemana: '7 days for only 79€',
		inicioReservarPlaza: 'Book your place',
		inicioPlazaGarantizada: 'By reserving a space with us, your parking at the port of Barcelona is guaranteed.',
		inicioCancelacionReembolso: 'If you need to cancel your reservation, you can do so with the option of a refund up to 7 days before.',
		inicioAhorra: 'Save with competitive rates for short and long stay.',
		inicioTituloPlazaGarantizada: 'Your place is guaranteed',
		inicioTituloCancelacionReembolso: 'Cancellation with refund',
		inicioTituloAhorra: 'Save on parking',
		inicioConsulteRestricciones: 'Restrictions',
		inicioZBE: 'Low Emission Zone',
		menuReservar: 'Book',
		menuFaq: 'FAQ',
		menuFuncionamiento: 'How it works?',
		menuContacto: 'Contact',
		menuCancelar: 'Cancel booking',
		servicioAireLibre: 'Open air car park, open 24/7 ',
		servicioCodigoQr: 'License plate reader and QR code',
		servicioVideoVigilancia: 'Video surveillance',
		servicioAlturaMaxima: 'Maximum height 2.35m',
		servicioZbe: 'Low emission zone',
		servicioPlazasMinusvalidos: 'Disabled places',
		servicioCancelacionReserva: 'Free cancellation up to 7 days before the start of the reservation',
		listadoCruceros: 'Find your cruise',
		descripcionZBE1: 'We inform you that since January 1 the Barcelona City Council has put into operation the new low emission zone (ZBE) that restricts the circulation of certain vehicles throughout the city. It is for this reason that to access our parking lot they will have to check if their vehicle (national or foreign registration) is authorized to be able to circulate in this area.',
		descripcionZBE2: 'We attach the link to the official website of the Barcelona City Council, so that they can access all the information where they can register if necessary.',
		preguntasFrecuentes: 'Frequent questions',
		pregunta1: 'How do you access the car park?',
		pregunta1Parrafo1: 'If you have made the reservation through our website you simply approach the barrier in your vehicle and the barrier will open automatically – our system will read your number plate with a camera. It is for this reason that it is important to make sure you register your vehicle registration correctly.',
		pregunta1Parrafo2: 'In the event that the reader does not read your registration correctly, you can access it using the QR code that will be sent to you by email when you make the reservation. You can take it printed or on your mobile.',
		pregunta1Parrafo3: 'If the barrier is not opened automatically for any reason, you can contact the parking management directly by pressing the orange INFORMATION button.',
		pregunta2: 'How do I get out of the car park?',
		pregunta2Parrafo1: 'If you have made the reservation through our website you simply approach the barrier in your vehicle and the barrier will open automatically – our system will read your number plate with a camera. It is for this reason that it is important to make sure you register your vehicle registration correctly.',
		pregunta2Parrafo2: 'In the event that the reader does not read your registration correctly, you can access it using the QR code that will be sent to you by email when you make the reservation. You can take it printed or on your mobile.',
		pregunta2Parrafo3: 'If the barrier is not opened automatically for any reason, you can contact the parking management directly by pressing the orange INFORMATION button.',
		pregunta3: 'Can you park in any space?',
		pregunta3Parrafo1: 'Yes, the reservation is for any space that is currently available at the moment you enter. There are several disabled bays reserved for persons with reduced mobility.',
		pregunta3Parrafo2: '',
		pregunta3Parrafo3: '',
		pregunta4: 'Can I pick up the vehicle later than the time I had booked?',
		pregunta4Parrafo1: 'We advise that if you are unable to return to collect your vehicle at the time booked online, you contact the parking management.  Extending a booking is possible so long as there is availability.',
		pregunta4Parrafo2: '',
		pregunta4Parrafo3: '',
		pregunta5: 'If I arrive before the reserved time, will I be able to enter?',
		pregunta5Parrafo1: 'We advise our clients to arrive at the reserved time, but we understand that this is not always possible and, therefore, we have a reasonable courtesy time (1 hour before and 1 hour after their reservation). If upon arrival, the barrier does not open automatically, or through the QR code, you will have to contact the parking administration, pressing the orange INFORMATION button. Access will be granted provided there is availability.',
		pregunta5Parrafo2: '',
		pregunta5Parrafo3: '',
		pregunta6: 'Can I modify the registration once the reservation is made?',
		pregunta6Parrafo1: 'Yes, please send a request for change to: parkingbarcelonaport@es.costa.it, indicating the reservation code and the registration will be modified so that you do not have any problem when accessing the parking.',
		pregunta6Parrafo2: '',
		pregunta6Parrafo3: '',
		pregunta7: 'Is the car park easy to find?',
		pregunta7Parrafo1: 'Our car park is the only long stay parking lot on the cruise pier. Our car park has entry and exit barriers and is located just beyond Terminal Helix (Terminal E). See our map on the website for more information. Make sure you do not leave your vehicle parked in unauthorized zones outside of our car park as it will be towed or clamped by the Port Authority.',
		pregunta7Parrafo2: '',
		pregunta7Parrafo3: '',
		pregunta8: 'How long in advance do I have to make the online reservation to benefit from the best price?',
		pregunta8Parrafo1: 'If there are spaces available, you can book up to two hours before your arrival.',
		pregunta8Parrafo2: '',
		pregunta8Parrafo3: '',
		pregunta9: 'Is the parking lot near my cruise ship',
		pregunta9Parrafo1: 'The Pier Adossat is the dock where the 5 cruise terminals of the Port of Barcelona are located.',
		pregunta9Parrafo2: 'If you know in which terminal your ship will dock, ',
		pregunta9link: 'click here',
		pregunta9Parrafo3: ' to find out the walking distance between your terminal and the parking lot',
		pregunta10: 'What are the maximum vehicle dimensions that the car park accepts?',
		pregunta10Parrafo1: 'Access is limited by a maximum width of 300 cm and a height clearance of 235 cm. The size of each space is 490x240 cm. Buses, large caravans, vehicles with trailers etc. are not allowed.',
		pregunta10Parrafo2: 'Disabled spaces are adapted to the corresponding legislation.',
		pregunta10Parrafo3: '',
		pregunta11: 'Is there an electric charging station?',
		pregunta11Parrafo1: 'No, at the moment we do not have this service.',
		pregunta11Parrafo2: '',
		pregunta11Parrafo3: '',
		pregunta12: 'Is there cleaning service? ',
		pregunta12Parrafo1: 'No, at the moment we do not have this service.',
		pregunta12Parrafo2: '',
		pregunta12Parrafo3: '',
		pregunta13: 'Is the parking guarded?',
		pregunta13Parrafo1: 'The car park is monitored by CCTV.  Access to the area of the cruise pier (where the car park is located) is restricted by the Port Police and unauthorized access is not permitted. The Port Police patrols are constant in the area.',
		pregunta13Parrafo2: '',
		pregunta13Parrafo3: '',
		pregunta14: 'Is the parking garage covered?',
		pregunta14Parrafo1: 'No, it\'s exposed.',
		pregunta14Parrafo2: '',
		pregunta14Parrafo3: '',
		pregunta15: 'Is there a key custody service?',
		pregunta15Parrafo1: 'No, please keep your keys on you as we do not offer this service.',
		pregunta15Parrafo2: '',
		pregunta15Parrafo3: '',
		pregunta16: 'What happens if I lose the ticket?',
		pregunta16Parrafo1: 'You will find instructions at the ATM',
		pregunta16Parrafo2: '',
		pregunta16Parrafo3: '',
		reservaConfirmada: 'CONFIRMED RESERVATION',
		infoTiempoCortesia: 'You will have an entry / exit margin of one hour with respect to the effective reservation time.',
		tablaTarifaDiaPorHoras: 'One day',
		tablaTarifaHoras: 'One hour',
		tablaTarifaHorasTitulo: 'Standard parking rate',
		tablaTarifaHorasPrecio: 'Amount',
		reservaCancelada: 'The reservation has been canceled and the amount paid on the credit card',
		datosReservaTarjeta: 'Credit card',
		errorPlazoCancelacion: 'Your reservation starts in less than 7 days and cannot be canceled by this means.',
		funcionamientoEstancia: 'Defines the reservation period',
		funcionamientoDatosPersonales: 'Identify yourself',
		funcionamientoDatosFacturacion: 'Will you need an invoice?',
		funcionamientoPago: 'Make the reservation payment',
		funcionamientoReservaRealizada: 'Congratulations, you have finished your reservation.',
		funcionamientoCancelarReserva: 'Do you want to cancel your reservation?',
		funcionamientoP1P1: 'Enter the data that defines the period of the reservation (day/time of entry and day/time of departure), the information of the vehicle you are going to use (registration number, model and color) and the cruise you will embark on. Part of this data is required by the Port Authority for security reasons.',
		funcionamientoP1P2: 'Our website will inform you of the amount to be paid for the period of time entered. You may see a warning if the departure date is not later than the arrival date.',
		funcionamientoP1P3: 'Please note that the web booking fee is for full days. If you select less than 24 hours you will be charged one day of stay; if you exceed 24 hours for one minute, you will be charged two days.',
		funcionamientoP1P4: 'Press the "BOOK" button to continue the process.',
		funcionamientoP2P1: 'We need to know minimum information about you; In this way we will be able to have a communication channel with you and identify you in case you need to ask us.',
		funcionamientoP3P1:	'If you think you will need a nominal invoice for your stay, enter the tax billing information. It\'s not mandatory.',
		funcionamientoP4P1: 'On the screen you will see a form to enter the data of the card with which you are going to make the payment.',
		funcionamientoP4P2: 'This form is completely secure and complies with current regulations for online payments. Parking Barcelona Port does not have access to your card data, since it is a direct and shielded communication with the payment gateway.',
		funcionamientoP5P1: 'If the payment process concludes correctly you will see this reservation confirmation screen.',
		funcionamientoP5P2: 'The most relevant data is the reservation locator code and the QR code that will be used to access the car park in the event that there is a problem with the automatic license plate reading system.',
		funcionamientoP5P3: 'You will receive an email with the reservation information. We recommend that you keep this email in case the parking employees ask for it.',
		funcionamientoP6P1: 'If there are more than 7 days until the start of your reservation, you can cancel it automatically and free of charge.',
		funcionamientoP6P2: 'Press the "CANCEL BOOKING" button that you will find in the menu bar of the page. When you do, a window will appear for you to enter your email and the reservation locator number. With these data we can recover all the necessary information.',
		funcionamientoP6P3: 'If you are in the cancellation period and you have correctly entered the data, all the information associated with the reservation will be shown: Start date and time, end date and time, amount paid, etc. Pressing the "CANCEL" button will cancel the reservation in the parking lot and refund the amount paid on your credit card.',

		mensajeCookies: 'We use our own and third party cookies to improve the user experience and improve our services. If you accept or continue browsing, we consider that you accept their use.',
		enlaceCookies: 'Cookies policy',
		aceptarCookies: 'I agree',
		accionesReserva: 'My reservations',
		reviseSuCorreo: 'You will receive an email with your invoice'
		
	},	// fin traduccion a ingles

	'fr': {
		superadaAntelacionMaxima: 'Il n\'est pas possible de réserver plus de 183 jours à l\'avance (6 mois environ)',
		horaInicialErronea: 'Mauvaise heure d\'entrée',
		tiempoRestanteParaFinalizarReserva: 'Le temps de finaliser la réservation: ',
		errorCaracteresMatricula: 'Uniquement des lettres et des chiffres',
		errorObteniendoDisponibilidad: 'Erreur lors de l\'obtention de la disponibilité des places.',
		plazasNoDiponibles: 'Il n\'y a pas de places disponibles aux dates indiquées.',
		obtenerFactura: 'Obtenir la facture',
		cancelarReserva: 'Annuler la réservation',
		avisolegal: 'Conditions d\'utilisation',
		politicaprivacidad:'Politique de la protection des données personnelles',
		pagoseguro:	'Paiement sécurisé avec',
		copyright:'Créé par',
		horario:'Lundi au dimanche 24 heures',
		comollegar: 'COMMENT ARRIVER',
		minutos: 'minutes',
		puertobarcelona: 'Port de Barcelone',
		palaciovirreina: 'Palais de la Virreina',
		teatroliceo: 'Gran Teatre del Liceu',
		larambla: 'La Rambla',
		boqueria: 'Marché de la Boqueria',
		plazareal: 'Plaça Reial',
		direccionpuerto: 'Port de Barcelone',
		direccionpalacio: 'La Rambla, 99, 08001 Barcelona',
		direccionteatro: 'La Rambla, 51-59, 08002 Barcelona',
		direccionrambla: 'La Rambla, 08002 Barcelona',
		direccionboqueria: 'La Rambla, 91, 08001 Barcelona',
		direccionplazareal: 'Plaza Real, 9, 08002 Barcelona',
		dia: 'jour',
		dias: 'jours',
		duracion: 'DURÉE',
		importe: 'MONTANT',
		tablaTarifaDias: 'Jours',
		tablaTarifaPrecio1: 'Prix en ligne exclusif',
		tablaTarifaPrecio2: '',
		tablaTarifaTitulo: 'NOTRE TARIF',
		errorObteniendoTarifa: 'Tarif non téléchargé',
		datosReservaTitulo: 'COMPLÉTEZ VOTRE RÉSERVATION',
		datosReservaFechaEntrada: 'Date d\'entrée',
		datosReservaFechaSalida: 'Date de sortie',
		datosReservaMatricula: 'Immatriculation',
		datosReservaModelo: 'Modèle de véhicule',
		datosReservaColor: 'Couleur du véhicule',
		datosReservaCrucero: 'Croisière',
		datosReservaPrecioTotal: 'Parking rèserve',
		datosReservaTotal: 'Total',
		datosReservaNombre: 'Nom complet',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Numéro de téléphone',
		datosReservaAceptoCondiciones: 'J\'accepte les termes et conditions du service',
		datosReservaInformacionFacturacion: 'Données de facturation',
		datosReservaNombreFac: 'Nom complet',
		datosReservaCif: 'CAF',
		datosReservaDireccion: 'Adresse',
		datosReservaLocalidad: 'Localité',
		datosReservaCp: 'Code postal',
		datosReservaLocalizador: 'Localisateur',
		datosReservaQR: 'Code QR',
		miReservaTitulo: 'Données de réservation',
		errorNoNombre: 'Données obligatoires',
		errorNoEmail: 'Données obligatoires',
		errorEmailErroneo: 'Veuillez saisir un e-mail valide',
		errorNoAceptaTerminos: 'Données obligatoires',
		errorNoTelefono: 'Données obligatoires',
		errorNoFechaEntrada: 'Données obligatoires',
		errorNoFechaSalida: 'Données obligatoires',
		errorNoMatricula: 'Données obligatoires',
		errorNoModelo: 'Données obligatoires',
		errorNoColor: 'Données obligatoires',
		errorNoCrucero: 'Données obligatoires',
		errorNoLocalizador: 'Données obligatoires',
		errorReservaNoEncontrada: 'Réserve non trouvée',
		btnBuscarReserva: 'Recherche réservation',
		btnReservar: 'Réserver',
		btnTerminar: 'Finir',
		btnImprimir: 'Imprimer',
		btnContinuar: 'Continuer',
		btnCancelar: 'Annuler',
		btnSolicitarFactura: 'Demande la facture',
		fechaFinalErronea: 'Date de fin incorrecte',
		reservaMayorPermitido: 'La réservation dépasse la durée maximale autorisée (14 jours)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Choses à voir et à faire à proximité',
		descripcionParking: 'Description',
		descripcionParkingP1: 'Parking Barcelona Port est un parking public situé à l\'intérieur du port de Barcelone, Terminal E.',
		descripcionParkingP2: 'Vous pouvez laisser votre voiture en sécurité ainsi que profiter de vos vacances sans soucis et éviter d’avoir à rechercher un transfert. Le parking idéal si vous partez en croisière avec Costa Cruceros, Aida cruises, parmi beaucoup d’autres, car le parking se trouve à quelques minutes à pied de l’entrée des gares maritimes.',
		descripcionParkingP3: 'Grâce à notre site, vous pouvez réserver une place dans notre parking pour votre voiture pendant les dates de votre choix. De cette façon, vous vous assurez un stationnement.',
		descripcionParkingP4: ' Nous avons un total de 275 places de stationnement disponibles, et 9 places pour les personnes à mobilité réduite. Parking ouvert tous les jours, 24h/24h. Toutes nos places de stationnement sont découvertes et sont surveillées en permanence par des caméras de sécurité.',
		presentacionDireccion: 'Adresse',
		presentacionHorario: 'Horaires',
		presentacionServicios: 'Services',
		presentacionPubli: 'Réservation en ligne votre Parking Cruise Terminal Barcelone',
		presentacionAccesos: 'Accès et départs',
		presentacionDias: 'Lundi à dimanche	24 heures',
		presentacionDireccionParking: 'Derrière Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'TES DONNÉES',
		steperRealizarPago: 'PAIEMENT',
		stepperResultadoProceso: 'RÉSERVÉ',
		resumenTitulo: 'Résumé de réservation',
		resumenPrecio: 'PRIX',
		resumenSubTotal: 'Sous total',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Annulation gratuite 7 heures avant.',
		resumenPieGarantia:'Place de parking garantie.',
		resumenAvisoDevolucion: 'Le montant sera payé sur la même carte utilisée dans le paiement',
		resumenImporteAbonado: 'Le montant payé',
		condicionesUso: 'Conditions du service',
		politicaDevolucion: ' Conditions, politique d\'annulation et de remboursement',
		y:'et',
		resumenAvisoCorreo: 'Vous recevrez un mail avec tous les détails de votre réservation.',
		resumenAvisoCorreoFactura: 'Vous recevrez un e-mail avec votre facture.',
		resumenContacto: 'En cas d\'annulation ou changement de date, nous vous rappelons que c\'est entièrement gratuit GRATUITO, envoyez un mail à parkingbarcelonaport@es.costa.it ou appelez au +34 911 410 171',
		stepperContinuarPago: 'Aceptar condicones y continuar con el pago',
		inicioBienvenido: 'BIENVENUE',
		inicioNombreParking: 'Parking Barcelona Port',
		inicioReservaConNosotros: 'Si vous partez en croisière depuis le Moll Adossat dans le port de Barcelone, réservez votre place de parking avec nous. Situé à côté de la station maritime Helix Cruise Center, Terminal E.',
		inicioSomosUnicos: 'NOUS SOMMES LE SEUL PARKING DE LONG SÉJOUR SUR LE QUAI DE CROISIÈRE DU PORT DE BARCELONE',
		inicioPrecioSemana: '7 jours pour 79€',
		inicioReservarPlaza: 'Réservez votre place',
		inicioPlazaGarantizada: 'En réservant une place avec nous, votre parking au port de Barcelone est garanti.',
		inicioCancelacionReembolso: 'Si vous devez annuler votre réservation, vous pouvez le faire avec l\'option d\'un remboursement jusqu\'à 7 jours avant.',
		inicioAhorra: 'Économisez avec des tarifs compétitifs pour des séjours courts et longs.',
		inicioTituloPlazaGarantizada: 'Votre place est garantie',
		inicioTituloCancelacionReembolso: 'Annulation avec remboursement',
		inicioTituloAhorra: 'Économisez sur le stationnement',
		inicioConsulteRestricciones: 'Voir Restrictions',
		inicioZBE: 'Zone à faibles émissions',
		menuReservar: 'Réserver',
		menuFaq: 'FAQ',
		menuFuncionamiento: 'Comment ça marche?',
		menuContacto: 'Contact',
		menuCancelar: 'Annuler la réservation',
		servicioAireLibre: 'Découvert et ouvert 24 heures',
		servicioCodigoQr: 'Lecteur de plaque d\'immatriculation et code QR',
		servicioVideoVigilancia: 'Vidéosurveillance',
		servicioAlturaMaxima: 'Hauteur maximale 2,35m',
		servicioZbe: 'Zone à faibles émissions',
		servicioPlazasMinusvalidos: 'Places mobilité réduite',
		servicioCancelacionReserva: 'Annulation gratuite jusqu\'à 7 jours avant le début de la réservation',
		listadoCruceros: 'Trouvez votre croisière',
		descripcionZBE1: 'Nous vous informons que depuis le 1er janvier la Mairie de Barcelone a mis en service la nouvelle zone à faibles émissions (ZBE) qui restreint la circulation de certains véhicules dans toute la ville. C\'est pour cette raison que pour accéder à notre parking, vous devrez vérifier si votre véhicule (immatriculation nationale ou étrangère) est autorisé à circuler dans cette zone.',
		descripcionZBE2: 'Nous attachons le lien vers le site officiel de la Mairie de Barcelone, afin vous puissiez accéder à toutes les informations et où vous pourrez vous inscrire si nécessaire.',
		preguntasFrecuentes: 'Questions fréquentes',
		pregunta1: 'Comment accédez-vous au parking?',
		pregunta1Parrafo1: 'Si vous avez réservé via notre site Web, il vous suffit de vous approcher de la barrière avec votre véhicule et celle-ci s\'ouvrira automatiquement. Notre système lira votre plaque d\'immatriculation avec une caméra. C’est pour cette raison qu’il est important de vous assurer d’enregistrer votre immatriculation de voiture correctement.',
		pregunta1Parrafo2: 'Dans le cas où le lecteur ne lirait pas correctement votre plaque d’immatriculation, vous pouvez y accéder en utilisant le code QR qui vous sera envoyé par email lors de votre réservation. Vous pouvez le prendre imprimé ou sur votre mobile',
		pregunta1Parrafo3: 'Si la barrière n\'est pas ouverte automatiquement pour une raison quelconque, vous pouvez contacter directement la direction du stationnement en appuyant sur le bouton orange INFORMATION.',
		pregunta2: 'Comment puis-je sortir du parking?',
		pregunta2Parrafo1: 'Si vous avez réservé via notre site Web, il vous suffit de vous approcher de la barrière avec votre véhicule et celle-ci s\'ouvrira automatiquement. Notre système lira votre plaque d\'immatriculation avec une caméra. C’est pour cette raison qu’il est important de vous assurer d’enregistrer votre immatriculation de voiture correctement.',
		pregunta2Parrafo2: 'Dans le cas où le lecteur ne lirait pas correctement votre plaque d’immatriculation, vous pouvez y accéder en utilisant le code QR qui vous sera envoyé par email lors de votre réservation. Vous pouvez le prendre imprimé ou sur votre mobile',
		pregunta2Parrafo3: 'Si la barrière n\'est pas ouverte automatiquement pour une raison quelconque, vous pouvez contacter directement la direction du stationnement en appuyant sur le bouton orange INFORMATION.',
		pregunta3: 'Pouvez-vous vous garer dans n\'importe quel espace?',
		pregunta3Parrafo1: 'Oui, la réservation concerne tout espace actuellement libre au moment où vous le souhaitez. Plusieurs baies sont réservées aux personnes à mobilité réduite.',
		pregunta3Parrafo2: '',
		pregunta3Parrafo3: '',
		pregunta4: 'Puis-je récupérer le véhicule après la fin de la réservation en ligne?',
		pregunta4Parrafo1: 'Si vous ne pouvez pas venir chercher votre véhicule au moment de la fin de la réservation en ligne, nous vous conseillons de contacter la direction du stationnement en appuyant sur le bouton orange INFORMATION. Prolonger une réservation est possible tant qu\'il y a de la disponibilité.',
		pregunta4Parrafo2: '',
		pregunta4Parrafo3: '',
		pregunta5: 'Si j\'arrive avant l\'heure réservée, pourrai-je entrer?',
		pregunta5Parrafo1: 'Nous conseillons à nos clients d\'arriver à l\'heure réservée, mais nous comprenons que ce n\'est pas toujours possible et, par conséquent, nous avons un temps de courtoisie raisonnable (1 heure avant et 1 heure après leur réservation). Si à l\'arrivée, la barrière ne s\'ouvre pas automatiquement, ou via le code QR, vous devrez contacter l\'administration du parking en appuyant sur le bouton orange INFORMATION. L\'accès sera accordé sous réserve de disponibilité.',
		pregunta5Parrafo2: '',
		pregunta5Parrafo3: '',
		pregunta6: 'Puis-je modifier l\'inscription une fois la réservation effectuée?',
		pregunta6Parrafo1: 'Oui, veuillez envoyer une demande de modification à: parkingbarcelonaport@es.costa.it, en indiquant le code de réservation et l\'enregistrement seront modifiés afin que vous n\'ayez aucun problème pour accéder au parking.',
		pregunta6Parrafo2: '',
		pregunta6Parrafo3: '',
		pregunta7: 'Le parking est-il facile à trouver?',
		pregunta7Parrafo1: 'Le parking est le seul parking de longue durée sur le quai de croisière. Notre parking a des barrières d’entrée et de sortie et il est situé juste au-delà du Terminal Helix (Terminal E). Voir notre carte sur le site pour plus d\'informations. Assurez-vous de ne pas laisser votre véhicule stationné dans des zones non autorisées à l’extérieur de notre parking car il sera remorqué ou sous sabot d\'immobilisation par l’autorité portuaire.',
		pregunta7Parrafo2: '',
		pregunta7Parrafo3: '',
		pregunta8: 'Combien de temps à l\'avance dois-je effectuer ma réservation en ligne pour bénéficier du meilleur prix?',
		pregunta8Parrafo1: 'Si des places sont disponibles, vous pouvez réserver jusqu\'à deux heures avant votre arrivée.',
		pregunta8Parrafo2: '',
		pregunta8Parrafo3: '',
		pregunta9: 'Le parking est-il près de mon paquebot?',
		pregunta9Parrafo1: 'Le quai de croisière Adossat est le quai où se trouvent les 5 terminaux de croisière du port de Barcelone.',
		pregunta9Parrafo2: 'Si vous savez à quel terminal votre paquebot accostera, ',
		pregunta9link: 'cliquez ici',
		pregunta9Parrafo3: ' pour connaître la distance de marche entre votre terminal et le parking.',
		pregunta10: 'Quelles sont les dimensions maximales du véhicule acceptées par le parking?',
		pregunta10Parrafo1: 'L\'accès est limité par une largeur maximale de 300 cm et une hauteur libre de 235 cm. La taille de chaque espace est de 490x240 cm. Les bus, les grandes caravanes, les véhicules avec remorques, etc. ne sont pas autorisés.',
		pregunta10Parrafo2: 'Les places pour les personnes à mobilité réduite sont adaptées à la législation correspondante.',
		pregunta10Parrafo3: '',
		pregunta11: 'Y a-t-il une station de charge électrique?',
		pregunta11Parrafo1: 'Non, pour le moment nous n\'avons pas ce service.',
		pregunta11Parrafo2: '',
		pregunta11Parrafo3: '',
		pregunta12: 'Y a-t-il un service de nettoyage?',
		pregunta12Parrafo1: 'Non, pour le moment nous n\'avons pas ce service.',
		pregunta12Parrafo2: '',
		pregunta12Parrafo3: '',
		pregunta13: 'Le parking est-il gardé?',
		pregunta13Parrafo1: 'Le parking est surveillé par CCTV video surveillance. L\'accès à la zone du quai de croisière (où se trouve le parking) est limité par la police du port et lorsqu\'il n\'y a pas de paquebot l\'accès au quai de croisière Adossat au personnel non autorisé n\'est pas autorisé. Les patrouilles de la police du port sont constantes dans cette zone.',
		pregunta13Parrafo2: '',
		pregunta13Parrafo3: '',
		pregunta14: 'Le garage est-il couvert?',
		pregunta14Parrafo1: 'Non, c\'est un parking a l’air libre.',
		pregunta14Parrafo2: '',
		pregunta14Parrafo3: '',
		pregunta15: 'Existe-t-il un service de garde des clés?',
		pregunta15Parrafo1: 'Non, veuillez garder vos clés sur vous car nous n\'offrons pas ce service.',
		pregunta15Parrafo2: '',
		pregunta15Parrafo3: '',
		pregunta16: 'Que se passe-t-il si je perds le billet?',
		pregunta16Parrafo1: 'Vous trouverez des instructions au GAB',
		pregunta16Parrafo2: '',
		pregunta16Parrafo3: '',
		reservaConfirmada: 'RÉSERVATION CONFIRMÉE',
		infoTiempoCortesia: 'Vous disposerez d\'une marge d\'entrée / sortie d\'une heure par rapport à l\'heure de réservation effective.',
		tablaTarifaDiaPorHoras: 'Une jour',
		tablaTarifaHoras: 'Une heure',
		tablaTarifaHorasTitulo: 'Frais de stationnement standard',
		tablaTarifaHorasPrecio: 'Montant',
		reservaCancelada: 'La réservation a été annulée et le montant payé sur la carte de crédit',
		datosReservaTarjeta: 'Carte de crédit',
		errorPlazoCancelacion: 'Votre réservation commence dans moins de 7 jours et ne peut être annulée par ce moyen.',
		funcionamientoEstancia: 'Définit la période de réservation',
		funcionamientoDatosPersonales: 'Identifiez-vous',
		funcionamientoDatosFacturacion: 'Aurez-vous besoin d\'une facture?',
		funcionamientoPago: 'Effectuer le paiement de la réservation',
		funcionamientoReservaRealizada: 'Félicitations, vous avez terminé votre réservation.',
		funcionamientoCancelarReserva: 'Voulez-vous annuler votre réservation?',
		funcionamientoP1P1: 'Saisissez les données qui définissent la période de la réservation (jour/heure d\'entrée et jour / heure de départ), les informations du véhicule que vous allez utiliser (numéro d\'immatriculation, modèle et couleur) et la croisière sur laquelle vous embarquerez. Une partie de ces données est requisé par l\'Autorité Portuaire pour des raisons de sécurité.',
		funcionamientoP1P2: 'Notre site Internet vous informera du montant à payer pour la période saisie. Un avertissement peut s\'afficher si la date de départ n\'est pas postérieure à la date d\'arrivée.',
		funcionamientoP1P3: 'Veuillez noter que les frais de réservation en ligne s\'appliquent aux journées complètes. Si vous sélectionnez moins de 24 heures, un jour de séjour vous sera facturé; si vous dépassez 24 heures pendant une minute, vous serez facturé deux jours.',
		funcionamientoP1P4: 'Appuyez sur le bouton "RÉSERVER" pour continuer le processus.',
		funcionamientoP2P1: 'Nous devons connaître un minimum d\'informations vous concernant. De cette façon, nous pourrons avoir un canal de communication avec vous et vous identifier au cas où vous auriez besoin de nous le demander.',
		funcionamientoP3P1:	'Si vous pensez que vous aurez besoin d\'une facture nominale pour votre séjour, entrez les informations de facturation fiscale. Ce n\'est pas obligatoire.',
		funcionamientoP4P1: 'Sur l\'écran, vous verrez un formulaire pour entrer les données de la carte avec laquelle vous allez effectuer le paiement.',
		funcionamientoP4P2: 'Ce formulaire est entièrement sécurisé et conforme à la réglementation en vigueur pour les paiements en ligne. Parking Barcelona Port n\'a pas accès aux données de votre carte, car il s\'agit d\'une communication directe et securisée avec la plate-forme de paiement.',
		funcionamientoP5P1: 'Si le processus de paiement se termine correctement, vous verrez cet écran de confirmation de réservation.',
		funcionamientoP5P2: 'Les données les plus pertinentes sont le code de localisation de réservation et le code QR qui seront utilisés pour accéder au parking en cas de problème avec le système de lecture automatique des plaques d\'immatriculation.',
		funcionamientoP5P3: 'Vous recevrez un e-mail avec les informations de réservation. Nous vous recommandons de conserver cet e-mail au cas où les employés du parking le demanderaient.',
		funcionamientoP6P1: 'S\'il reste plus de 7 jours avant le début de votre réservation, vous pouvez l\'annuler automatiquement et gratuitement.',
		funcionamientoP6P2: 'Appuyez sur le bouton "ANNULER LA RESERVATION" que vous trouverez dans la barre de menu de la page. Lorsque vous le faites, une fenêtre apparaîtra pour vous permettre de saisir votre e-mail et le numéro du localisateur de réservation. Avec ces données, nous pouvons récupérer toutes les informations nécessaires.',
		funcionamientoP6P3: 'Si vous êtes dans la période d\'annulation et que vous avez correctement saisi les données, toutes les informations associées à la réservation seront affichées: date et heure de début, date et heure de fin, montant payé, etc. Appuyer sur le bouton «ANNULER» annulera la réservation dans le parking et remboursera le montant payé sur votre carte de crédit.',

		mensajeCookies: 'Nous utilisons nos propres cookies et ceux de tiers pour améliorer l\'expérience utilisateur et améliorer nos services. Si vous acceptez ou continuez à naviguer, nous considérons que vous acceptez leur utilisation.',
		enlaceCookies: 'Politique de cookies',
		aceptarCookies: 'Je suis d\'accord',
		accionesReserva: 'Mes réservations',
		reviseSuCorreo: 'Vous recevrez un email avec votre facture'


	},	// fin traduccion a frances

	'ca': {
		superadaAntelacionMaxima: 'No és possible reservar amb una antelació més gran de 183 dies (6 mesos aprox.)',
		horaInicialErronea: 'Hora d\'entrada errònia',
		tiempoRestanteParaFinalizarReserva: 'Temps per finalitzar la reserva: ',
		errorCaracteresMatricula: 'Només lletres i números',
		errorObteniendoDisponibilidad: 'Error obtenint la disponibilitat de places.',
		plazasNoDiponibles: 'No hi ha places disponibles per a les dates marcades.',
		obtenerFactura: 'Obtenir factura',
		cancelarReserva: 'Cancel·lar reserva',
		avisolegal: 'Termes del servei',	
		politicaprivacidad:'Política de Privacitat',
		pagoseguro:	'Pagament segur amb',
		copyright:'Creat per',
		horario:'Dilluns a diumenge 24 hores',
		comollegar: 'COM ARRIBAR',
		minutos: 'minuts',
		puertobarcelona: 'Port de Barcelona',
		palaciovirreina: 'Palau de la Virreina',
		teatroliceo: 'Grand teatre del Liceu',
		larambla: 'La Rambla',
		boqueria: 'Mercat de la Boqueria',
		plazareal: 'Plaça Reial',
		direccionpuerto: 'Port de Barcelona',
		direccionpalacio: 'La Rambla, 99, 08001 Barcelona',
		direccionteatro: 'La Rambla, 51-59, 08002 Barcelona',
		direccionrambla: 'La Rambla, 08002 Barcelona',
		direccionboqueria: 'La Rambla, 91, 08001 Barcelona',
		direccionplazareal: 'Plaça Reial, 9, 08002 Barcelona',
		dia: 'dia',
		dias: 'dies',
		duracion: 'DURADA',
		importe: 'IMPORT',
		tablaTarifaDias: 'Dies',
		tablaTarifaPrecio1: 'Preu exclusiu online',
		tablaTarifaPrecio2: '',
		tablaTarifaTitulo: 'LA NOSTRA TARIFA',
		errorObteniendoTarifa: 'Tarifa no descarregada',
		datosReservaTitulo: 'COMPLETA LA TEVA RESERVA',
		datosReservaFechaEntrada: 'Data d\'entrada',
		datosReservaFechaSalida: 'Data de sortida',
		datosReservaMatricula: 'Matrícula',
		datosReservaModelo: 'Model de vehicle',
		datosReservaColor: 'Color de vehicle',
		datosReservaCrucero: 'Creuer',
		datosReservaPrecioTotal: 'Reserva de parking',
		datosReservaTotal: 'Total',
		datosReservaNombre:'Nom complet',
		datosReservaEmail: 'Email',
		datosReservaTelefono: 'Número de telèfon',
		datosReservaAceptoCondiciones: 'Accepto els termes i condicions de l\'servei',
		datosReservaInformacionFacturacion: 'Dades de facturació',
		datosReservaNombreFac: 'Nom complet',
		datosReservaCif: 'CIF',
		datosReservaDireccion: 'Direcció',
		datosReservaLocalidad: 'Localitat',
		datosReservaCp: 'Codi postal',
		datosReservaLocalizador: 'Localitzador',
		datosReservaQR: 'Códi QR',
		miReservaTitulo: 'Dades de la reserva',
		errorNoNombre: 'Dada obligatòria',
		errorNoEmail: 'Dada obligatòria',
		errorEmailErroneo: 'Introduïu un email vàlid',
		errorNoAceptaTerminos: 'Dada obligatòria',
		errorNoTelefono: 'Dada obligatòria',
		errorNoFechaEntrada: 'Dada obligatòria',
		errorNoFechaSalida: 'Dada obligatòria',
		errorNoMatricula: 'Dada obligatòria',
		errorNoModelo: 'Dada obligatòria',
		errorNoColor: 'Dada obligatòria',
		errorNoCrucero: 'Dada obligatòria',
		errorNoLocalizador: 'Dada obligatòria',
		errorReservaNoEncontrada: 'Reserva no trobada',
		btnBuscarReserva: 'Cercar reserva',
		btnReservar: 'Reservar',
		btnTerminar: 'Acabar',
		btnImprimir: 'Imprimir',
		btnContinuar: 'Continuar',
		btnCancelar: 'Cancel',
		btnSolicitarFactura: 'Sol·licitar factura',
		fechaFinalErronea: 'Fecha final errónea',
		reservaMayorPermitido: 'La reserva supera la durada màxima permesa (14 dies)',
		datosReservaHoraEntrada: '',
		datosReservaHoraSalida: '',
		lugaresInteres: 'Punts pròxims',
		descripcionParking: 'Descripció',
		descripcionParkingP1: 'Parking Barcelona Port és un aparcament públic de Barcelona situat dins el Port, al costat de la terminal E.',
		descripcionParkingP2: 'Podràs deixar el teu cotxe aparcat de forma segura i gaudir de les teves vacances sense preocupacions i evitant buscar trasllats. L\'aparcament ideal si et vas de creuer amb Costa Cruceros, Aida cruises, entre molts altres operadors ja que el parking està a escassos minuts caminant de les terminals des d\'on surten.',
		descripcionParkingP3: 'Mitjançant la nostra web podràs reservar una plaça en el nostre parking per al teu cotxe durant les dates que seleccions. D\'aquesta manera, t\'assegures d\'aparcar.',
		descripcionParkingP4: 'Disposem en total de 275 places d\'aparcament, més 9 places habilitades per a discapacitats. Disponibles per aparcar els 365 dies de l\'any i obert les 24 hores. Totes les nostres places de parking són descobertes i estan vigilades en tot moment per càmeres de seguretat.',
		presentacionDireccion: 'Direcció',
		presentacionHorario: 'Horaris',
		presentacionServicios: 'Servei',
		presentacionPubli: 'Reserva Online el teu aparcament al port de Barcelona',
		presentacionAccesos: 'Accessos i sortides',
		presentacionDias: 'Dilluns a diumenge 24 hores',
		presentacionDireccionParking: 'Darrere Terminal E - HELIX, Moll Adossat, 08039, Barcelona',
		stepperComprobarDatos: 'TEVES DADES',
		steperRealizarPago: 'PAGAMENT',
		stepperResultadoProceso: 'RESERVA',
		resumenTitulo: 'Resum de reserva',
		resumenPrecio: 'PREU',
		resumenSubTotal: 'Subtotal',
		resumenTotal: 'TOTAL',
		resumenPieCancelacion: 'Cancel·lació gratuïta 7 hores abans.',
		resumenPieGarantia:'Plaça d’aparcament garantida.',
		resumenAvisoDevolucion: 'L\'import s\'abonarà en la mateixa targeta utilitzada en el pagament',
		resumenImporteAbonado: 'Import abonat',
		condicionesUso: 'Condicions de serveis',
		politicaDevolucion: ' Condicions, Política de Cancel·lació i Reemborsament',
		y:'y',
		resumenAvisoCorreo: 'Rebràs un correu electrònic amb tots els detalls de la reserva.',
		resumenAvisoCorreoFactura: 'Rebràs un email amb la teva factura.',
		resumenContacto: 'En cas que vulguis corregir qualsevol detall després de la seva reserva, per favor contacta amb nosaltres a parking@bct.com',
		stepperContinuarPago: 'Aceptar condicones y continuar con el pago',
		inicioBienvenido: 'BENVINGUT',
		inicioNombreParking: 'Parking Barcelona Port',
		inicioReservaConNosotros: 'Si surts en un creuer des del Moll Adossat del port de Barcelona, reserva la teva plaça de parking amb nosaltres. Situat al costat de l\'Helix Cruise Center, Terminal E.',
		inicioSomosUnicos: 'SOM L\'ÚNIC PARKING DE LLARGA ESTADA AL MOLL DE CREUERS DEL PORT DE BARCELONA',
		inicioPrecioSemana: '7 dies per només 79€',
		inicioReservarPlaza: 'Reserva la teva plaça',
		inicioPlazaGarantizada: 'Reservant un plaça amb nosaltres, el teu parking al port de Barcelona està garantit.',
		inicioCancelacionReembolso: 'Si necessites cancel·lar la teva reserva, podràs fer-ho amb opció a reemborsament fins a 7 dies abans.',
		inicioAhorra: 'Estalvia amb tarifes competitives per a estada curta i llarga.',
		inicioTituloPlazaGarantizada: 'La teva plaça està garantida',
		inicioTituloCancelacionReembolso: 'Cancel·lació amb reemborsament',
		inicioTituloAhorra: 'Estalvia en parking',
		inicioConsulteRestricciones: 'Consulteu Restriccions',
		inicioZBE: 'Zona de Baixes Emissions',
		menuReservar: 'Reservar',
		menuFaq: 'FAQ',
		menuFuncionamiento: 'Com funciona?',
		menuContacto: 'Contacte',
		menuCancelar: 'cancel·lar reserva',
		servicioAireLibre: 'Descobert i obert 24h',
		servicioCodigoQr: 'Lector de matrícules i codi QR',
		servicioVideoVigilancia: 'Videovigilància',
		servicioAlturaMaxima: 'Alçada màxima 2,35m',
		servicioZbe: 'Zona de baixes emissions',
		servicioPlazasMinusvalidos: 'Places per a minusvàlids',
		servicioCancelacionReserva: 'Cancel·lació gratuïta fins a 7 dies abans de l\'inici de la reserva',
		listadoCruceros: 'Troba el teu creuer',
		descripcionZBE1: 'Els informem que des de l\'1 de gener l\'Ajuntament de Barcelona ha posat en funcionament la nova zona de baixes emissions (ZBE) que restringeix la circulació de certs vehicles per la ciutat. És per aquest motiu que per accedir al nostre estacionament hauran de comprovar si el seu vehicle (matrícula nacional o estrangera) està autoritzat per poder circular en aquesta zona.',
		descripcionZBE2: 'Adjuntem el link de la pàgina oficial de l\'Ajuntament de Barcelona, perquè puguin accedir a tota la informació on podran registrar en cas de ser necessari.',
		preguntasFrecuentes: 'Preguntes freqüents',
		pregunta1: 'Com s\'accedeix al parking?',
		pregunta1Parrafo1: 'Si ha realitzat la reserva a través de la nostre web només ha d’apropar-se amb el cotxe a la barrera i la barrera s’obrirà automàticament, el nostre sistema llegirà la seva matricula amb una càmara. És per aquest motiu que és important registrar el seu vehicle correctament.',
		pregunta1Parrafo2: '',
		pregunta1Parrafo3: 'Si la barrera no s’obre automàticament per qualsevol motiu, podrà contactar directament amb l’administració del parking prement el botó taronja d\'INFORMACIÓ',
		pregunta2: 'Com surto del parking?',
		pregunta2Parrafo1: 'Si ha realitzat la reserva a través de la nostre web només ha d’apropar-se amb el cotxe a la barrera i mitjançant el sistema de lector de matrícules (APNR) se li obrirà automàticament. És per aquest motiu que és important registrar el seu vehicle correctament.',
		pregunta2Parrafo2: '',
		pregunta2Parrafo3: 'Si la barrera no s’obre automàticament per qualsevol motiu, podrà contactar directament amb l’administració del parking prement el botó taronja d\'INFORMACIÓ.',
		pregunta3: 'Es pot aparcar a qualsevol plaça?',
		pregunta3Parrafo1: 'Sí, la reserva és per qualsevol plaça que estigui lliure en el moment que vostè arribi al parking. Hi ha diverses places per a minusvàlids reservades per a persones amb mobilitat reduïda',
		pregunta3Parrafo2: '',
		pregunta3Parrafo3: '',
		pregunta4: 'Puc retirar el cotxe més tard de l\'hora que tenia reservada?',
		pregunta4Parrafo1: 'L\'informem que si no pot arribar a recollir el seu cotxe a l\'hora reservada per la web s’ha de posar en contacte amb l\'administració de l\'estacionament. Estendre la reserva és possible, sempre que hi hagi disponibilitat.',
		pregunta4Parrafo2: '',
		pregunta4Parrafo3: '',
		pregunta5: 'Si arribo abans de l\'hora reservada, podré entrar?',
		pregunta5Parrafo1: 'Aconsellem als nostres clients que arribin a l\'hora reservada, però entenem que això no és sempre possible i, per tant, tenim un temps de cortesia raonable (1 hora abans i 1 hora després de la seva reserva). Si a l\'arribar, la barrera no s\'obre automàticament, ni mitjançant el codi QR, haurà de contactar amb l\'administració de l\'aparcament, prement el botó taronja d\'INFORMACIÓ. S\'atorgarà l\'accés sempre que hi hagi disponibilitat.',
		pregunta5Parrafo2: '',
		pregunta5Parrafo3: '',
		pregunta6: 'Què passa si perdo el tiquet?',
		pregunta6Parrafo1: 'Al caixer automàtic trobarà instruccions.',
		pregunta6Parrafo2: '',
		pregunta6Parrafo3: '',
		pregunta7: 'Puc modificar la meva reserva un cop feta?',
		pregunta7Parrafo1: 'Sí, ha d\'enviar una sol·licitud de canvi via email a: parkingbarcelonaport@es.costa.it, indicant el codi de reserva i el registre i es modificarà perquè no tingui cap problema a l’hora d’accedir al nostre pàrquing.',
		pregunta7Parrafo2: '',
		pregunta7Parrafo3: '',
		pregunta8: 'És fàcil trobar el parking?',
		pregunta8Parrafo1: 'En el Moll Adossat és l\'únic estacionament de llarga estada. El nostre estacionament té barreres d\'entrada i sortida i està situat just al costat de la Terminal E (HELIX). Pot consultar el mapa a la nostra web per a més informació.',
		pregunta8Parrafo2: '. Cuideu-vos de no deixar el cotxe aparcat en una de les esplanades	destinades a ús de dia, perquè a la tornada del creuer el seu cotxe se’l podria haver emportat la grua o estar bloquejat amb un cep.',
		pregunta8Parrafo3: '',
		pregunta9: 'El parking està a prop del meu creuer?',
		pregunta9Parrafo1: 'El Moll Adossat és el moll en el qual s\'ubiquen les 5 terminals de creuers del Port de Barcelona.',
		pregunta9Parrafo2: 'Si coneix a quina terminal atracarà el seu vaixell, ',
		pregunta9Parrafo3: ' per conèixer la distància caminant entre les terminals i el parking.',
		pregunta9link: 'cliqui aquí',
		pregunta10: 'Amb quant temps d\'antelació he de fer la reserva online per a beneficiar-me del millor preu?',
		pregunta10Parrafo1: 'Si hi ha places, pot reservar fins a dues hores abans de la seva arribada.',
		pregunta10Parrafo2: '',
		pregunta10Parrafo3: '',
		pregunta11: 'Quines són les dimensions màximes de vehicle que accepta el parking?',
		pregunta11Parrafo1: 'L\'accés està limitat per una amplada màxima de 300 cm i un gàlib de 235 cm. Les mesures de la plaça són 490x240 cm. No estan permesos autobusos, caravanes de grans dimensions, vehicles amb remolc.',
		pregunta11Parrafo2: 'Les places per a minusvàlids estan adequades a la legislació corresponent.',
		pregunta11Parrafo3: '',
		pregunta12: 'Hi ha estació de recàrrega elèctrica?',
		pregunta12Parrafo1: 'No, de moment no disposem d\'aquest servei.',
		pregunta12Parrafo2: '',
		pregunta12Parrafo3: '',
		pregunta13: 'Hi ha servei de neteja?',
		pregunta13Parrafo1: 'No, de moment no disposem d\'aquest servei.',
		pregunta13Parrafo2: '',
		pregunta13Parrafo3: '',
		pregunta14: 'El parking està vigilat?',
		pregunta14Parrafo1: 'Sí, està vigilat per CCTV. La zona del Moll Adossat (on es troba l’estacionament) és d\'accés restringit i quan no hi ha vaixell a les terminals no es permet l\'accés a personal no autoritzat. Les patrulles de Policia Portuària estan constantment donant voltes per la zona.',
		pregunta14Parrafo2: '',
		pregunta14Parrafo3: '',
		pregunta15: 'El parking està cobert?',
		pregunta15Parrafo1: 'No, està al descobert.',
		pregunta15Parrafo2: '',
		pregunta15Parrafo3: '',
		pregunta16: 'Hi ha servei de custòdia de claus?',
		pregunta16Parrafo1: 'No, mantingui les claus amb vostè, ja que no oferim aquest servei.',
		pregunta16Parrafo2: '',
		pregunta16Parrafo3: '',
		reservaConfirmada: 'RESERVA CONFIRMADA',
		infoTiempoCortesia: 'Disposarà d\'un marge d\'entrada / sortida d\'una hora respecte a el temps efectiu de servei.',
		tablaTarifaDiaPorHoras: 'Un dia',
		tablaTarifaHoras: 'Una hora',
		tablaTarifaHorasTitulo: 'Tarifa estàndard d\'estacionament',
		tablaTarifaHorasPrecio: 'Import',
		reservaCancelada: 'La reserva ha estat cancel·lada i el seu import abonat a la targeta de crèdit',
		datosReservaTarjeta: 'Targeta de crèdit',
		errorPlazoCancelacion: 'La seva reserva comença en menys de 7 dies i no es pot desfer per aquest mitjà.',
		funcionamientoEstancia: 'Defineix el període de reserva',
		funcionamientoDatosPersonales: 'Identifica\'t',
		funcionamientoDatosFacturacion: 'Necessitaràs una factura?',
		funcionamientoPago: 'Realitza el pagament de la reserva',
		funcionamientoReservaRealizada: 'Enhorabona, has acabat la teva reserva.',
		funcionamientoCancelarReserva: 'Vols cancel·lar la teva reserva?',
		funcionamientoP1P1: 'Introdueix les dades que defineixen el període de la reserva (dia/hora d\'entrada i dia/hora de sortida), la informació del vehicle que utilitzaràs (nombre de matrícula, model i color) i el creuer en què embarcaràs. Part d\'aquestes dades són exigides per l’Autoritat Portuària per motius de seguretat.',
		funcionamientoP1P2: 'La nostra web t\'informarà de l\'import a pagar per al període de temps introduït. Pot aparèixer un avís en cas que la data de sortida no sigui posterior a la d\'entrada.',
		funcionamientoP1P3: 'Tingues present que la tarifa de reserva web és per dies complets. Si selecciones menys de 24 hores se\'t cobrarà un dia d\'estada; si superes les 24 hores per un minut, se\'t cobraran dos dies.',
		funcionamientoP1P4: 'Prem el botó "RESERVAR" per continuar amb el procés.',
		funcionamientoP2P1: 'Necessitem conèixer una informació mínima sobre tu, d\'aquesta manera podrem tenir un canal de comunicació amb tu i identificar-te en cas que necessitis realitzar-nos alguna consulta.',
		funcionamientoP3P1:	'Si creus que necessitaràs una factura nominativa de la teva estada, introdueix les dades fiscals de facturació. No és obligatori.',
		funcionamientoP4P1: 'En pantalla veuràs un formulari per introduir les dades de la targeta amb la qual vas a realitzar el pagament.',
		funcionamientoP4P2: 'Aquest formulari és totalment segur i compleix amb la normativa vigent per a pagaments per internet. Parking Barcelona Port no té accés a les dades de la teva targeta, ja que es tracta d\'una comunicació directa i blindada amb la passarel·la de pagaments.',
		funcionamientoP5P1: 'Si el procés de pagament conclou correctament veuràs aquesta pantalla de confirmació de reserva.',
		funcionamientoP5P2: 'Les dades més rellevants són el codi del localitzador de la reserva i el codi QR que et servirà per accedir a l\'aparcament en cas que hi hagués algun problema amb el sistema automàtic de lectura de matrícula.',
		funcionamientoP5P3: 'Rebràs un email amb les dades de la reserva. Et recomanem que conservis aquest mail per si te’l demanen els empleats de l\'aparcament.',
		funcionamientoP6P1: 'Si falten més de 7 dies fins al moment d\'inici de la reserva, pots cancel·lar-de manera automàtica i gratuïta.',
		funcionamientoP6P2: 'Prem el botó "CANCEL·LAR RESERVA" que trobareu a la barra de menú de la pàgina. Quan ho facis apareixerà una finestra per introduir el teu email i el número de localitzador de la reserva. Amb aquestes dades podrem recuperar tota la informació necessària.',
		funcionamientoP6P3: 'Si estàs en termini de cancel·lació i has introduït correctament les dades, se\'t mostrarà tota la informació associada a la reserva: Data i hora d\'inici, data i hora de finalització import pagat, etc. Prement el botó "CANCEL·LAR" s\'anul·larà la reserva al parking i se\'t retornarà l\'import pagat a la targeta de crèdit.',

		mensajeCookies: 'Utilitzem cookies pròpies i de tercers per millorar l\'experiència d\'usuari i millorar els nostres serveis. Si accepta o continua navegant, considerem que accepta el seu ús.',
		enlaceCookies: 'Política de cookies',
		aceptarCookies: 'Estic d\'acord',
		accionesReserva: 'Les meves reserves',
		reviseSuCorreo: 'Rebreu un correu electrònic amb el vostre fet'

	}	// fin traduccion a catalan
};

export default new VueI18n({ locale: 'es', 			// set locale    
							fallbackLocale: 'es', 	// set fallback locale
							messages 				// set locale messages
				});
				